import React from "react";
import { Tabs } from "antd";
import UserReport from "./reports/UserReport";
import OrderReport from "./reports/OrderReport";
import RestaurantReport from "./reports/RestaurantReport";
const { TabPane } = Tabs;
const Reports = () => {
  const onChange = (key) => {
    console.log(key);
  };
  const tabStyle = {
    color: "rgba(0, 0, 0, 0.65)",
    fontWeight: "600",
  };
  return (
    <>
      <Tabs
        defaultActiveKey="1"
        tabBarStyle={{ backgroundColor: "white" }}
        style={{}}
        onChange={onChange}
      >
        <TabPane tab={<span style={tabStyle}>User Report</span>} key="1">
          <>
            <UserReport />
          </>
        </TabPane>
        <TabPane tab={<span style={tabStyle}>Order Report</span>} key="2">
          <>
            <OrderReport />
          </>
        </TabPane>
        <TabPane tab={<span style={tabStyle}>Restaurant Report</span>} key="3">
          <>
            <RestaurantReport />
          </>
        </TabPane>
      </Tabs>
    </>
  );
};

export default Reports;
